import { Translation } from "../types";

const translation: Translation = {
  login: "Log in",
  register: "Register",
  loginWithEmail: "Have you received an invitation? <0>Login with email</0>.",
  buyParkingPermit: "Buy parking permit",
  manageVehicles: "Manage vehicles",
  wellbeingServicesCounty: "Wellbeing services county of North Pohjanmaa",
  errors: {
    LimitExceededException: "Too many attemps. Please try again later.",
  },
  unknownError: "An unknown error occurred. Please try again later.",
  navbar: {
    title: "Staff parking",
    menuTooltip: "Open menu",
    finnish: "Suomeksi",
    english: "In English",
    swedish: "På svenska",
    logout: "Log out",
    userDetails: "User details",
    drawer: {
      firstPage: "Front page",
      shop: "Store",
      userInfo: "User info, vehicles and permits",
      helpdesk: "Helpdesk",
      faq: "See the answers to the most frequently asked questions.",
      termsAndConditions: "Terms of use",
      privacyPolicy: "Privacy policy",
      contactInformation: "Contact information",
      paymentPolicy: "Payment policy",
    },
  },
  privacyPolicy: {
    title: undefined,
    paragraphs: undefined,
  },
  parkingMap: {
    title: "Parking areas & permits",
    description: `Purchased staff parking permits are valid in the welbeing services county facilities 
		with the exception of KYS Puijo hospital campus`,
    listedLocations: "See all locations listed",
  },
  footer: {
    helpdesk: "Helpdesk",
    faq: "See the answers to the <0>most frequently asked questions</0>.",
  },
  home: {
    title: "Staff parking permit web store",
    disclaimer: {
      p1: "Please note that only email addresses of actors of the wellbeing services county are allowed for login.",
      p2: "These are @pshyvinvointialue.fi, @servica.fi, @istekki.fi, @islab.fi, @sakupe.fi, and @jstt.fi.",
    },
    flow: {
      login: {
        title: "Log in",
        description:
          "Parking permits for staff parking can only be purchased by logged-in Pohde users.",
      },
      buyParkingPermit: {
        title: "Buy parking permit",
        description:
          "In the web store, permits can be purchased easily and will be activated when you place your order.",
      },
      manageVehicles: {
        title: "Manage vehicles",
        description:
          "In the service, you can manage the vehicle activated for your permit. Remember to keep the information up-to-date!",
      },
    },
    webshop: {
      title: "Web store",
    },
  },
  loginForm: {
    title: "Log in",
    email: "Enter email address",
    password: "Enter password",
    forgotPassword: "Forgot password?",
    submit: "Log in",
    authenticationError: "Invalid email address or password",
    tokenExpired: "Your session has expired. Log in again.",
  },
  registerForm: {
    title: "Create an account",
    email: "Enter email address",
    password: "Enter password",
    confirmPassword: "Re-enter password",
    invalidPassword:
      "Password must be at least 8 characters long and contain at least one number, one uppercase letter, and one special character.",
    passwordMismatch: "Passwords do not match",
    userAlreadyExists:
      "The user already exists. If you had parking permits in the previous system or have forgotten your password, <0>you can reset your password here</0>.",
    userAlreadyExistsHelpText: "User already exists",
    invalidEmail:
      "Please note that only email addresses ending with @pshyvinvointialue.fi, @servica.fi, @istekki.fi, @islab.fi, @sakupe.fi, or @jstt.fi are allowed.",
    submit: "Create account",
    acceptTerms: "I accept the <0>terms and conditions</0>*",
    acceptTermsRequired: "Please accept the terms and conditions to continue",
  },
  termsAndConditions: {
    title: "Sopimusehdot",
    heading: "POHJOIS-POHJANMAAN HYVINVOINTIALUEEN HENKILÖSTÖPYSÄKÖINTI",
    general: {
      subheading: "Yleistä tietoa",
      body: `
      Pohjois-Pohjanmaan hyvinvointialueen työntekijät voivat hankkia henkilöstöpysäköintiluvan oman työpisteensä 
      läheisyydestä. Joissakin kohteissa on rajattu määrä myytäviä pysäköintioikeuksia, joten osa alueista voidaan 
      myydä loppuun. Osassa verkkokaupan tuotteissa on rajaton määrä ostettavia pysäköintioikeuksia, mutta tarkempi 
      rajaus tehdään yksittäisellä kiinteistöllä. Esimerkiksi "kausimaksu" paikkoja on rajattomasti myynnissä, mutta 
      tarkemmat lämpöpaikkojen jakamiset tehdään kiinteistökohtaisesti.
      <br><br>
      Pysäköintioikeuden lunastaminen ei takaa paikan saatavuutta. On mahdollista, että kyseisellä alueella ei ole 
      paikkoja vapaana, vaikka olet lunastanut pysäköintioikeuden. Täysien paikkojen tapauksessa ei korvauksia tai 
      hyvityksiä anneta. Pysäköintimaksuja ei palauteta, jos työsuhde päättyy kesken maksetun kauden tai poissaolon, 
      kuten esimerkiksi sairasloman vuoksi. Sähkö- ja hybridiautojen lataaminen sekä sisätilanlämmittimen käyttö on 
      kielletty.`,
    },
    conditions: {
      subheading: "Sopimusehdot",
      parties: {
        subheading: "i. Sopijapuolet",
        body: `
				1. Pysäköintiluvan haltija<br>
				2. Finnpark Oy / Pohjois-Pohjanmaan hyvinvointialue
			`,
      },
      subject: {
        subheading: "ii. Sopimuksen kohde",
        body: `
				Tässä sopimuksessa määritellään pysäköintiluvan ehdot, käyttö ja voimassaoloaika. Pysäköintilupa viittaa 
				maksulliseen (sähköiseen/digitaaliseen) lupaan, jota käytetään henkilö- ja pakettiautoissa, ja joka antaa 
				oikeuden pysäköidä verkkokaupan tuotteen määrittelemälle alueelle, liikennemerkkien mukaisesti.
			`,
      },
      content: {
        subheading: "iii. Sopimuksen sisältö",
        body: `
				Pysäköintilupia myönnetään Pohjois-Pohjanmaan hyvinvointialueen ja sen konsernin henkilöstölle. Ajoneuvon 
				tulee olla liikennekäytössä ja sopijapuolen omistama, hallitsema tai muutoin pysyvästi tai pitkäaikaisesti 
				käytössä. Pysäköintilupa on henkilökohtainen ja sitä saa käyttää vain työhön tai työskentelyyn liittyvässä 
				pysäköinnissä. Lupaa ei saa lainata tai siirtää toiselle henkilölle.
			`,
      },
      terms: {
        subheading: "iv. Sopimuksen ehdot",
        body: `
				Ostettu pysäköintilupa ei takaa pysäköintipaikkaa, mikäli kaikki pysäköintipaikat ovat varattuna. Luvanhaltija 
				on velvollinen tarkastamaan luvan käyttöoikeuden pysäköintialueella. Pysäköintilupaa saa käyttää ainoastaan 
				liikennemerkkien mukaisella pysäköintialueella. Lupa ei oikeuta pysäköimään pysäköinninvalvonnasta annetun 
				lain vastaisesti.
				<br><br>
        Pohjois-Pohjanmaan hyvinvointialueella on oikeus muuttaa ja rajoittaa pysäköintiä tarpeen mukaan, esimerkiksi
        kunnossapidon vuoksi. Hyvinvointialue ei vastaa internetissä tai ohjekartoissa olevista virheellisistä 
        tiedoista. Hyvinvointialue pidättää oikeuden muuttaa pysäköintialueiden liikenne- ja pysäköintijärjestelyjä 
        tapahtumien tai muiden vastaavien syiden ajaksi. Hyvinvointialue voi tiedottaa pysäköintiluvan 
        haltijaa kunnossapito- ja muista töistä sopivalla tavalla. Työmaiden tai muiden syiden aiheuttamista 
        luvan käytön estymisistä tai haitoista ei makseta korvausta.
        <br><br>
        Työntekijän vastuulla on huolehtia pysäköintioikeuden irtisanomisesta, mikäli työsuhde päättyy. Maksut 
        suoritetaan toistuvina maksuina eli maksut eivät pääty automaattisesti, vaikka työsuhde päättyisikin. 
        Työntekijän tulee myös huolehtia, että toistuvaan maksuun valittu maksukortti on voimassa sekä huolehtia 
        maksukortin päivityksestä maksulle. Pohjois-Pohjanmaan hyvinvointialue ei palauta maksuja tai valvontamaksuja
        näissä tapauksissa.
		`,
      },
      otherTerms: {
        subheading: "v. Muut ehdot",
        body: `
				Sopimus tulee voimaan, kun lupamaksu on kokonaisuudessaan suoritettu. Lupa voidaan peruuttaa ilman 
				irtisanomisaikaa luvan väärinkäyttötilanteissa (esim. luovuttaminen toisen osapuolen käyttöön) eikä 
				sopijapuolella ole tällöin oikeutta lupamaksun palautukseen tai muuhun korvaukseen. Tämän sopimuksen 
				pätevyyttä, tulkintaa ja soveltamista koskevat mahdolliset ristiriidat, joista osapuolet eivät pääse 
				yksimielisyyteen neuvotteluin, ratkaistaan tarvittaessa riita- asiana Oulun käräjäoikeudessa.`,
      },
    },
    close: "Close",
  },
  confirmEmailForm: {
    title: "Confirm email address",
    confirmationCode: "Enter confirmation code",
    resendEmail: "Resend",
    submit: "Confirm",
    confirmEmail:
      "A confirmation code has been sent to your email address. Enter it in the field below.",
    confirmationCodeError: "The confirmation code is invalid",
    confirmSuccess: "Email address successfully confirmed. You can now log in.",
    resendConfirmationCode: "Resend confirmation code",
  },
  forgotPasswordForm: {
    title: "Forgot your password?",
    confirmPasswordReset: "Enter confirmation code and new password",
    userNotFound: "User not found",
    submit: "Submit",
  },
  resetPasswordForm: {
    title: "Reset password",
    password: "Enter new password",
    confirmPassword: "Re-enter new password",
    resetPasswordSuccess: "Password changed successfully. You can now log in.",
  },
  userDetailsForm: {
    title: "Enter user details",
    email: "Email",
    firstName: "First name",
    lastName: "Last name",
    editName: "Edit name",
    phoneNumber: "Phone number",
    editPhoneNumber: "Edit phone number",
    changePassword: "Change password",
    oldPassword: "Current password",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password",
    wrongPasswordError: "Wrong password",
    passwordChangeSuccess: "Password changed successfully",
    submit: "Save",
  },
  userDetailsPage: {
    title: "User details, permits, and vehicles",
    purchaseParkingPermit: "Purchase a parking permit",
    parkingPermits: {
      title: "Parking permits",
      description:
        "Remember that only one vehicle/registration number can be active on a permit at a time.",
      activeVehicle: "Vehicle assigned to permit",
      noActiveVehicle: "No vehicle assigned to permit",
      invalidActiveVehicle: "Vehicle not found in the listed vehicles",
      changeActiveVehicle: "Change vehicle",
      noParkingPermits: "No valid parking permits",
      cancelConfirmationTitle: "Cancel subscription",
      cancelConfirmationText:
        "Are you sure you want to cancel your parking permit subscription? You can continue to park during the period of validity of the permit you have paid for.",
      cancelConfirmationTextPaidUntil:
        "Your licence is currently valid until {{ paid_until, string }}.",
      closeButton: "Continue subscription",
      confirmButton: "Yes, cancel the subscription",
      print: "Print",
      cancel: "Cancel subscription",
      cancelError: "Error happened, your subscription was not cancelled",
    },
    paymentCard: {
      paymentMethod: "Payment method",
      expiryText: "Valid {{month}}/{{year}}",
    },
  },
  vehiclesForm: {
    title: "Vehicles",
    subtitle: "You can add up to three vehicles.",
    licensePlate: "License plate",
    add: "Add vehicle",
    addInputLabel: "Enter license plate",
    addRequired: "Add a vehicle to purchase a permit",
    edit: "Edit vehicle {{ licensePlate, string }}",
    save: "Save vehicle",
    delete: "Remove vehicle {{ licensePlate, string }}",
    chooseVehicle: "Choose vehicle",
  },
  purchaseParkingPermit: {
    title: "Staff parking permit web store",
    description:
      "Staff can purchase regional permits. Only one license plate can be active per permit.",
    productsQueryError: "Error loading permit products, please try again later",
    parkingPermitType: "Choose permit to purchase",
    validityStartDate: "Permit validity starts",
    parkingPermitDuration: undefined,
    parkingPermitDescription: {
      p1: "Grants the right to park at staff parking spaces with or without motor heater plugs.",
      p2: "The purchased permit is valid at all wellbeing region locations except the KYS Puijo hospital campus managed by KYS parking facilities.",
    },
    validFromTitle: "Permit validity starts",
    validFrom: "Valid from:",
    validFromPurchase: "After purchase",
    validTo: "Valid until:",
    validDuration: "Valid for:",
    validDurationDays: "{{ days }} days",
    paidUntil: "Renews on",
    singlePaymentPrice: "Single payment:",
    submit: "Book and pay",
    hasEnded: "Ended",
    aboutToEnd: "About to end",
    conflict: {
      title: "Not available for purchase",
      content:
        "Unfortunately, all the permits are already in use. Please try again later.",
    },
    successPage: {
      title: "Checkout",
      description: "Thank you for ordering a parking permit.",
      orderDetails: "Order details",
      permitDetails: "Order information",
      orderDate: "Order date",
      orderNumber: "Order number",
      totalPrice: "Total price",
      paymentMethod: "Payment method",
      invoicingAddress: "Invoicing address",
      error: "An unexpected error occurred. Please contact customer service.",
    },
    cancelPage: {
      title: "Checkout",
      description: "Payment failed",
      lede: "Sometimes card payments fail",
      reasons: {
        preamble: "Reasons for this can be",
        causes: [
          "you canceled the payment",
          "there is insufficient balance on the bank account connected to a debit card",
          "credit limit is reached on a credit card",
          "there is a networking error between the payment processor and the issuing bank",
        ],
        postamble:
          "Make sure you have enabled online purchased on the card. If necessary, contact your bank for further assistance.",
      },

      returnToShop: "Return to shop",
    },
    recurrentBilling: "Price of a recurring subscription",
    recurrentBillingInfo:
      "The product has a recurring payment feature, which means that the payment will automatically renew 30 days after purchase unless you cancel your subscription before then.",
    singlePaymentInfo:
      "The product is a one-time payment and must be renewed manually after the permit expires.",
    includesVat: "incl. vat",
    dayAbrv: "day",
    noProducts: "You have no products to purchase",
  },
  paymentPolicy: {
    title: "Payment Service Provider",
    paragraphs: [
      `Paytrail Oyj serves as the payment intermediary and service provider in collaboration with 
		Finnish banks and credit institutions and is an authorized payment Institution. Paytrail Oyj will 
		be shown as the recipient on your bank or credit card statement and forward the payment to the merchant. 
		For complaints, please contact the website the payment was made to.`,
      "Paytrail Oyj",
      "Innova 2",
      "Lutakonaukio 7",
      "40100 Jyväskylä",
      "Business ID 2122839-7",
    ],
    paytrailUrl: "https://paytrail.com/en/consumer/information-about-paying",
  },
  contactInfo: {
    title: "Contact information",
    webshop:
      "Pohjois-Pohjanmaan hyvinvointialue staff parking permit web store",
    name: "Moovy Oy",
    noCustomerService: "Note: No customer service ",
    email: "Email",
    emailContent: "support@pohde.zendesk.com",
    businessId: "Business ID",
    businessIdContent: "3375902-1",
    postAddress: "Mail address",
    postAddressContent: "PL 15",
    city: "33211 Tampere",
  },
  paymentCardChangeSuccess: {
    title: "Change payment card",
    success: "Payment card change success",
    error: "Error while saving payment card",
  },
  paymentCardChangeCancel: {
    title: "Change payment card",
    text: "Payment card change was cancelled. Old payment card is still in use.",
  },
  requestSignIn: {
    title: "Login with email",
    email: "Email address",
    submit: "Send",
    success: "Sign In Link sent! Check your Email!",
  },
  tokenHandler: {
    info: "You are logging in to the parking permit web store with the email address",
    error:
      "Your email sign-in failed or has expired. Each email sign-up link is usable only once and must be used within 10 minutes of receiving",
    requestNewLink: "Request new link from <0>here</0>",
    submit: "Continue",
  },
  expiredEmailToken: {
    header: "Sign-in expired",
    text: "Your login via the email link has expired. For security reasons, your email login can only be used for 30 minutes. You can order a new login link <0>here</0>.",
  },
};

export default translation;
